import { currentBuilderState } from '../builder.state';

export function checkPeriodTypeParams(): void {
    const state = currentBuilderState();
    const vp = state.viewParams;

    if (vp.periodType?.id != null) {
        vp.periodType = state.periodTypes?.find(
            (e) => e.id === vp.periodType.id,
        );
    }
}
